/* eslint-disable @typescript-eslint/ban-types */
import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { Category } from '../types/index'

export interface CategoriesReducer {
  categories: Category[]
}

const initialState: CategoriesReducer = {
  categories: []
}

export const FETCH_CATEGORIES = createAction('categories_reducer/fetch_categories')
export const FETCH_CATEGORIES_SUCCESS = createAction<Category[]>('categories_reducer/fetch_categories_success')
export const FETCH_CATEGORIES_FAIL = createAction('categories_reducer/fetch_categories_fail')

export interface UpdateCategoryPayload {
  id: number
  to_50: number
  to_100: number
  to_200: number
  to_400: number
  to_600: number
  to_800: number
  to_1000: number
}
export type UpdateCategoryActionType = PayloadAction<UpdateCategoryPayload>
export const UPDATE_CATEGORY = createAction<UpdateCategoryPayload>('categories_reducer/update_category')
export const UPDATE_CATEGORY_SUCCESS = createAction('categories_reducer/update_category_success')
export const UPDATE_CATEGORY_FAIL = createAction('categories_reducer/update_category_fail')

export const categoriesReducer = createReducer(initialState, (builder) => {
  builder.addCase(FETCH_CATEGORIES_SUCCESS, (state, action) => {
    return { ...state, categories: action.payload }
  })
})

export default categoriesReducer
